import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const VideoWrapper = styled.div`
  margin: 1rem 0;

`;

export const Caption = styled.span`
  font-size: 12px;
  margin: 0;
  color: ${({ theme }) => theme.default.color.text.medium};
`;

export const Video = styled.video``;

export const FixedVideo = styled.video`
  position: fixed;
  height: 200px;
  width: 350px;
  top: 0;
  right: 100px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    height: 100px;
    width: 150px;
    right: 5px;
    z-index: 10000;
  }
`;
